import {State} from 'modules/auth/src/State';
import AuthModel from 'modules/auth/src/Model';

interface ClientConfig {
    backgroundUrl: string;
    logoUrl: string;
    name: string;
    description: string;
    typeAuth: Array<string>;
    url: string;
    enabledCaptcha: boolean;
}

export class Configuration {
    captchaImgUrl: string|null;
    backgroundUrl: string|null;
    captcha: object|null;
    oauth2Service: Array<string>;
    requestParams: object;

    isEsia: boolean;
    isEmail: boolean;
    isSocials: boolean;
    isPhone: boolean;

    clientName: string;
    clientDescription: string;
    projectName: string;
    esiaErrorMessage: string;
    esiaErrorMessageDetails: string;
    errorMessage: string;

    _state: State;
    _authModel: AuthModel;

    constructor() {
        const _window = (window as any);
        const initData = _window.BaseApp.initData;
        const authApp = initData.authApp as any;

        this.captchaImgUrl = authApp.captchaImgUrl || null;
        this.captcha = authApp.captcha || null;
        this.oauth2Service = authApp.auth.oauth2Service;
        this.requestParams = authApp.requestParams;

        this.isEsia = authApp.isEsia;
        this.isEmail = authApp.auth.isEmail;
        this.isPhone = authApp.auth.isPhone;
        this.isSocials = this.oauth2Service.length > 0;
        this.projectName = authApp.projectName;
        this.errorMessage = authApp.errorMessage;

        if (authApp.client) {
            const clientConfig = authApp.client as ClientConfig;
            this.isPhone = clientConfig.typeAuth.includes('phone');
            this.isEmail = clientConfig.typeAuth.includes('email');
            this.isEsia = clientConfig.typeAuth.includes('esia');
            this.isSocials = clientConfig.typeAuth.includes('socials');
            this.backgroundUrl = clientConfig.backgroundUrl;
            this.clientName = clientConfig.name;
            this.clientDescription = clientConfig.description;
            if (!clientConfig.enabledCaptcha) {
                this.captcha = null;
            }
        }

        this._state = new State();
        this._authModel = new AuthModel();

        // подтверждение после авторизаации из соц сети
        if (authApp.recoverState) {
            const recoverState = authApp.recoverState;
            if (recoverState.state === 'confirm' && recoverState.hash) {
                this._state.waitConfirm();
                this._authModel.hash = recoverState.hash;
                this._authModel.firstName = recoverState.user?.firstName;
                this._authModel.lastName = recoverState.user?.lastName;
                return;
            }
        }

        if (authApp.esiaErrorMessage) {
            this.esiaErrorMessage = authApp.esiaErrorMessage;
            this.esiaErrorMessageDetails = authApp.esiaErrorMessageDetails;
            this._state.esiaError();
        }
    }

    getState(): State {
        return this._state;
    }

    getAuthModel(): AuthModel {
        return this._authModel;
    }
}
